import { render, staticRenderFns } from "./clientList.vue?vue&type=template&id=6c45cbdd&scoped=true&"
import script from "./clientList.vue?vue&type=script&lang=js&"
export * from "./clientList.vue?vue&type=script&lang=js&"
import style0 from "./clientList.vue?vue&type=style&index=0&id=6c45cbdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c45cbdd",
  null
  
)

export default component.exports